import React from 'react';

const workflowIcon = () => {
    return (
        <svg
            focusable="false"
            viewBox="0 0 24 24"
            height="24"
            width="24"
            aria-hidden="true"
            data-testid="AccountTreeIcon">
            <path d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"></path>
        </svg>
    );
};

export default workflowIcon;
